// Raises a real Android notification when an ActionCable broadcast arrives, by handing the
// broadcast's type to the native shell.
//
// The web app already streams every notification over NotificationForUserChannel to keep the
// bell badge live. Inside the Hotwire Native shell that same socket can drive a system
// notification for free — no Firebase, no server change. It only works while the app's
// process is alive, so the useful window is the period after the user backgrounds the app,
// before Android reclaims it. Delivery to a fully closed app needs FCM.
//
// Only the type is sent, never any text. The native side owns the wording — see
// TomoNotificationBridge for why that matters (the interface is reachable by any script on
// the page, and notification copy must stay free of patient names and message content).

export function notifyNative(type) {
  const bridge = window.TomoNative

  // Absent in a normal browser, and on any shell built before this bridge existed.
  if (!bridge || typeof bridge.notify !== "function") return

  try {
    bridge.notify(type === "message" ? "message" : "other")
  } catch (error) {
    // A failed notification must never break the cable handler that updates the bell.
    if (window.console) console.warn("Native notification failed", error)
  }
}
